/**
 * PC Remote Library
 * Author: Preetha Ravichandran
 * Created On: 17-10-2023
 */
let number0 = 0;
export const handleNegativeScenario =(value:number | null | undefined)=>{
    if(value) {
        if(value > 0) {
          return value;
        } else {
          return number0;
        };
      }else {
        return number0;
      };
};